import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SpinnerFullPage from 'components/spinner/SpinnerFullPage';
import ForgotPasswordRequest from './ForgotPassword/ForgotPasswordRequest';
import ForgotPasswordReset from './ForgotPassword/ForgotPasswordReset';
import { forgotPasswordTokenValid } from 'services/User';

enum PageType {
  Request,
  Reset,
}

export default function ForgotPasswordForm(): JSX.Element {
  const [pageType, setPageType] = useState<PageType>();

  const location = useLocation();
  const navigate = useNavigate();

  /**
   * Check if we need to show the password reset form or request form
   */
  useEffect(() => {
    if (location.hash.startsWith('#token=')) {
      const abortController = new AbortController();

      // first check if the token is valid, if not return to the login page
      forgotPasswordTokenValid(location.hash.replace('#token=', ''), abortController.signal)
        .then(() => {
          setPageType(PageType.Reset);
        })
        .catch(error => {
          if (!abortController.signal.aborted) {
            console.error(error);
            navigate('/#forgot-password-token-invalid');
          }
        });

      return () => abortController.abort();
    } else {
      setPageType(PageType.Request);
    }
  }, [location.hash, navigate]);

  // show a loader if we are not sure what kind of page we should show
  if (pageType === undefined) {
    return <SpinnerFullPage spinnerProps={{ inverseColor: true }} />;
  }

  if (pageType === PageType.Request) {
    return <ForgotPasswordRequest />;
  }

  return <ForgotPasswordReset token={location.hash.replace('#token=', '')} />;
}
